// Skeleton placeholder that mirrors the SellerResultCard layout
// block-for-block (12-col tier-hero + details row, then the map + sidebar
// row, then the footer), so the loading -> result swap has no layout
// shift. Shown on the calculate/sell page while the pricing API is in
// flight. The seller flow has no AI-reasoning, findings, or reset blocks,
// so this skeleton doesn't render them.

import { SkeletonLine, SkeletonBlock, SkeletonCircle } from "./Skeleton";

export default function SellerResultCardSkeleton() {
  return (
    <div className="space-y-5 sm:space-y-6">
      {/* ROW 1: tier-hero (8 cols) + details (4 cols) */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 sm:gap-4 lg:items-start">
        {/* Tier hero */}
        <div className="lg:col-span-8 rounded-2xl border border-gray-200 bg-white p-5">
          {/* header strip: label + certainty ring */}
          <div className="flex items-center justify-between mb-4">
            <SkeletonLine width="w-32" className="h-3" />
            <SkeletonCircle size="w-9 h-9" />
          </div>
          {/* 3-up tier grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {[0, 1, 2].map((i) => (
              <div key={i} className="relative rounded-xl border border-gray-200 bg-white p-4">
                <SkeletonCircle size="w-10 h-10" className="absolute -top-2 -right-2" />
                <div className="flex items-center gap-1.5">
                  <SkeletonCircle size="w-3.5 h-3.5" />
                  <SkeletonLine width="w-16" className="h-3" />
                </div>
                <SkeletonLine width="w-3/4" className="mt-3 h-8" />
                <SkeletonLine width="w-12" className="mt-2 h-3" />
                <div className="mt-3 space-y-1.5">
                  <SkeletonLine width="w-full" className="h-3" />
                  <SkeletonLine width="w-4/5" className="h-3" />
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Details */}
        <div className="lg:col-span-4 rounded-2xl border border-gray-200 bg-white p-4 sm:p-5">
          <SkeletonLine width="w-20" className="h-3" />
          <div className="mt-4 grid grid-cols-2 lg:grid-cols-1 gap-x-3 gap-y-2.5">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center gap-2">
                <SkeletonCircle size="w-3.5 h-3.5" />
                <SkeletonLine width="w-16" className="h-3" />
                <SkeletonLine width="w-20" className="h-3 ml-auto" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ROW 2: amenities map (3/5) + sidebar (2/5) */}
      <div className="flex flex-col lg:flex-row gap-4 sm:gap-5 items-start">
        <SkeletonBlock height="h-64" className="lg:flex-[3] min-w-0 w-full" />
        <div className="lg:flex-[2] min-w-0 w-full space-y-4 sm:space-y-5">
          <SkeletonBlock height="h-28" />
          <SkeletonBlock height="h-32" />
          <SkeletonBlock height="h-72" />
        </div>
      </div>

      {/* Footer: feedback + disclaimer */}
      <div className="pt-2 space-y-3">
        <SkeletonBlock height="h-9" width="w-40" className="mx-auto" />
        <div className="max-w-2xl mx-auto space-y-1.5">
          <SkeletonLine width="w-full" className="h-2.5" />
          <SkeletonLine width="w-2/3" className="h-2.5 mx-auto" />
        </div>
      </div>
    </div>
  );
}
